<template>
    <div class="wxSend sp1 wxNoscroll" style="height: 100vh;">
        <wxBack v-show="shwoBottom"></wxBack>
        <div class="bgShow">
            <Row v-show="isRead && isFocus" class="logoImg">
                <img src="../../assets/dinnerMana/wxLogo.png" alt="">
            </Row>
            <Row>
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <Row class="mrT50" v-show="isRead">
                        <FormItem prop="username" class="userNameIcon">
                            <Input  @on-focus="displayImg" @on-blur="showImg" type="text" icon="ios-clock-outline" v-model="formInline.username" placeholder="请输入用户名">
                            </Input>
                        </FormItem>
                    </Row>
                    <Row class="mrT50" v-show="!isRead">
                        <Col class="leftName" span="6">
                            用&nbsp;&nbsp;户&nbsp;&nbsp;名
                        </Col>
                        <Col span="18">
                            <FormItem prop="username">
                                <Input disabled type="text" v-model="formInline.username" >
                                </Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50" v-show="!isRead">
                        <Col class="leftName" span="6">
                            真实姓名
                        </Col>
                        <Col span="18">
                            <FormItem prop="realName">
                                <Input type="text" v-model="formInline.realName">
                                </Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row class="mrT50" v-show="isRead">
                        <FormItem prop="password" class="psdIcon">
                            <Input @on-focus="displayImg"  @on-blur="showImg" type="password" icon="ios-clock-outline" v-model="formInline.password" placeholder="请输入密码">
                            </Input>
                        </FormItem>
                    </Row>
                    <Row class="mrT50" v-show="!isRead">
                        <Col class="leftName" span="6">
                            密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码
                        </Col>
                        <Col span="18">
                            <FormItem prop="password">
                                <Input type="password" v-model="formInline.password" >
                                </Input>
                            </FormItem>
                        </Col>

                    </Row>
                    <!-- <Row v-show="islock2">
                        <FormItem prop="realName">
                            <Input type="text" v-model="formInline.realName" placeholder="请输入真实姓名">
                                <Icon type="ios-locked-outline" slot="prepend"></Icon>
                            </Input>
                        </FormItem>
                    </Row> -->
                    <!-- <Row>
                        {{showIt}}
                    </Row> -->
                    <Row class="mrT50">
                        <FormItem>
                            <Button :class="{errBtn : !isRead}" class="sendButton" :type="islock" @click="send">{{buttonV}}</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Row>
        </div>
        <Row v-show="shwoBottom">
            <wxNav></wxNav>
        </Row>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxBack from "../wxBack"
    import wxNav from "../wxNav"
    export default {
        props: ["openid"],
        data () {
          return{
                isFocus:true,
                formInline: {
                    username: '',
                    password: '',
                    realName: ""
                },
                shwoBottom:false,
                isRead:false,
                showIt:{},
                ruleInline: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    realName: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' }
                    ]
                },
                islogin: true,
                islock: "success",
                islock2: false,
                buttonV: "加载中",
                title: "JM内务管理绑定"
            }
        },
        components:{
            wxNav,
            wxBack
        },
        computed: {
		    ...mapState(["xcxId","xcxUser","xcxReal","enter"]),
		},
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","CHANGE_ENTER"]),
            displayImg(){
                this.isFocus = false;
            },
            showImg(){
                this.isFocus = true;
            },
            send(){
                if(window.localStorage.getItem("isLogin") == "true"){
                    //解绑
                    var that = this;
                    let params = {};
                    params.url = "/manage/xiaocx/resetbinding";
                    params.token = "swgykj9527";
                    params.data = {
                        "password":this.formInline.password,
                        "realname":this.formInline.realName,
                        "xcx_openId":this.openid
                    };
                    params.success=function(res){
                        that.showIt = res;
                        if(res.data.code == "8888"){
                            that.$Message.error(res.data.message);
                        }else if(res.data.code == "0000"){
                            that.$Message.success(res.data.message);
                            window.localStorage.setItem("isLogin",false);
                            setTimeout(()=>{
                                var xcxIDXX = that.xcxId;
                                that.pdIt();
                                that.formInline.username = "";
                                that.formInline.password = "";
                                that.formInline.realName = "";
                                that.SET_XCXUSER("");
                                that.SET_XCXREAL("");
                                that.$router.replace('/data/wxSend/'+xcxIDXX);
                            },100)
                        }
                    };
                    that.ajaxPostWX(params);
                }else{
                    //绑定
                    var that = this;
                    let params = {};
                    params.url = "/manage/xiaocx/bindinguser";
                    params.token = "swgykj9527";
                    if(this.openid == window.localStorage.getItem("wxCode")){
                        params.data = {
                            "username":this.formInline.username,
                            "password":this.formInline.password,
                            "xcx_openId":this.openid
                        };
                    }else{
                        params.data = {
                            "username":this.formInline.username,
                            "password":this.formInline.password,
                            "xcx_openId":window.localStorage.getItem("wxCode")
                        };
                    }
                    params.success=function(res){
                        if(res.data.code == "8888"){
                            that.$Message.error(res.data.message);
                        }else if(res.data.code == "0000"){
                            that.SET_XCXID(res.data.result.xcx_openId);
                            that.SET_XCXUSER(res.data.result.username);
                            that.SET_XCXREAL(res.data.result.realname);
                            window.localStorage.setItem("isLogin",true);
                            that.$Message.success(res.data.message);
                            if(that.enter == "dinner"){
                                that.$router.push("/data/wxDinner/"+window.localStorage.getItem("wxCode"));
                            }else{
                                that.$router.replace("/data/wxProperty/"+window.localStorage.getItem("wxCode")+"/"+that.enter);
                                that.CHANGE_ENTER("dinner")
                            }
                        }else{
                            that.$Message.error(res.data.message);
                        }
                    };
                    that.ajaxPostWX(params);
                }
            },
            pdIt(){
                if(window.localStorage.getItem("isLogin") == "true"){
                    this.buttonV = "解除绑定";
                    this.shwoBottom = true;
                    this.formInline.username = this.xcxUser;
                    this.islock = "error";
                    this.islock2 = true;
                    this.ruleInline.username[0].required = false;
                    this.isRead = false;
                    this.title = "JM内务管理解绑";
                }else{
                    this.buttonV = "绑定并登录";
                    this.shwoBottom = false;
                    this.islock = "primary";
                    this.islock2 = false;
                    this.ruleInline.username[0].required = true;
                    this.isRead = true;
                    this.title = "JM内务管理绑定";
                }
            }
        },
        mounted: function() {
			this.pdIt();
        }
    }
</script>

<style lang="scss">
    .sp1{
        .bgShow{
            padding-top: 6vw;
        }
        .ivu-input-icon{
            left: 0;
        }
        .mrT50{
            margin-top: 3vw;
        }
        .sendButton{
            height: 12vw;
            width: 100%;
            border-radius: 10px;
            font-size: 4vw;
        }
        .userNameIcon {
            .ivu-input-icon-normal+.ivu-input{
                height: 12vw;
                font-size: 4vw;
                border-radius: 10px;
                text-indent: 13vw;
            }
            .ivu-icon{
                background: url("../../assets/dinnerMana/userIcon.png") center no-repeat;
                background-size: 6vw 6vw;
                height: 100%;
                width: 13vw;
            }
        }
        .psdIcon {
            .ivu-input-icon-normal+.ivu-input{
                height: 12vw;
                text-indent: 13vw;
                border-radius: 10px;
                font-size: 4vw;
            }
            .ivu-icon{
                background: url("../../assets/dinnerMana/psdIcon.png") center no-repeat;
                background-size: 6vw 6vw;
                height: 100%;
                width: 13vw;
            }
        }
        .ivu-icon-ios-clock-outline:before{
            content: "";
        }
        .errBtn{
            width: 80%;
            color: #fff;
            background: #e04b5c;
            position: absolute;
            bottom: -58vw;
            right: 10%;
        }
	    .ivu-form-inline .ivu-form-item{
	        width: 80%;
	    }
	    .ivu-input-group-append, .ivu-input-group>.ivu-input:last-child{
	        height: 40px;
	    }
    }
</style>


<style lang="scss">
    .sp1{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        .logoImg img{
            width: 30%;
            object-fit: contain;
            margin: 30px auto;
        }
        .bgShow{
            background: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 100%;
            width: 90%;
            z-index: 99;
            margin: 0 auto;
            .leftName{
                line-height: 40px;
                font-size: 4vw;
                text-align: center;
                color: #706767;
            }
        }
    }
    .bgShow{
        width: 90%;
        margin: 0 auto;
    }
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxSend.vue